import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../config/api';

const SearchBar = ({ onResults }) => {
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;
    
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/v1/search`, {
        params: { q: query, days: 30, limit: 20 }
      });
      if (onResults) onResults(res.data.results);
    } catch (err) {
      console.error('Search failed:', err);
    } finally {
      setLoading(false);
    }
  };

  const wrapperStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    background: '#fff',
    border: '2px solid #e0e0e0',
    borderRadius: '12px',
    padding: '8px 8px 8px 16px',
    maxWidth: '800px',
    margin: '0 auto 24px',
    boxSizing: 'border-box'
  };

  const iconStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    marginRight: '12px',
    color: '#999',
    flexShrink: 0
  };

  const inputStyle = {
    flex: '1 1 auto',
    minWidth: '200px',
    border: 'none',
    padding: '10px 12px 10px 0',
    fontSize: '16px',
    outline: 'none',
    background: 'transparent'
  };

  const buttonStyle = {
    flexShrink: 0,
    background: '#C41E3A',
    color: '#fff',
    border: 'none',
    padding: '10px 24px',
    borderRadius: '8px',
    fontWeight: '600',
    fontSize: '14px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    marginLeft: '8px'
  };

  return (
    <form onSubmit={handleSearch} data-testid="search-bar">
      <div style={wrapperStyle}>
        <span style={iconStyle}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
        </span>
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search stories, topics, figures..."
          style={inputStyle}
          data-testid="search-input"
        />
        <button type="submit" disabled={loading} style={buttonStyle} data-testid="search-submit">
          {loading ? 'Searching...' : 'Search'}
        </button>
      </div>
    </form>
  );
};

export default SearchBar;
